import { COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_ID, COMMUNICATION_CHART_EXTERNAL_NODE_ID, COMMUNICATION_CHART_OTHER_NODE_ID, getCommunicationChartTeamIdForCrossTeamSpaceNode, getCommunicationChartTeamIdForExternalSpaceNode, getCommunicationChartTeamIdForInternalNode } from '@web/components/CommunicationNetworkGraph/core/communicationChart/constants';
import { CommunicationChartNodeKindEnum, isCommunicationChartCrossTeamNodeKind, isCommunicationChartSyntheticNodeKind, isCommunicationChartTeamMemberNode } from '@web/components/CommunicationNetworkGraph/core/communicationChart/nodeKind';
import { isCommunicationChartEmployeeScope, isCommunicationChartTeamScope } from '@web/components/CommunicationNetworkGraph/core/communicationChart/types';
import { COMMUNICATION_CHART_BOTTOM_ANCHOR_Y_RATIO, COMMUNICATION_CHART_CROSS_TEAM_COLUMN_X_RATIO, COMMUNICATION_CHART_CROSS_TEAM_SPACE_NODE_ANGLE_OFFSET_RAD, COMMUNICATION_CHART_EMPLOYEE_TEAMMATE_COLUMN_X_RATIO, COMMUNICATION_CHART_EXTERNAL_SPACE_NODE_ANGLE_OFFSET_RAD, COMMUNICATION_CHART_HUB_SATELLITE_CENTER_EPSILON_PX, COMMUNICATION_CHART_INTERNAL_MEET_NODE_ANGLE_OFFSET_RAD, COMMUNICATION_CHART_OTHER_NODE_X_RATIO, COMMUNICATION_CHART_OTHER_NODE_Y_RATIO, COMMUNICATION_CHART_RING_BASE_RADIUS_RATIO, COMMUNICATION_CHART_RING_MAX_NODES_PER_RING, COMMUNICATION_CHART_RING_SPACING_RATIO, COMMUNICATION_CHART_SIDE_COLUMN_TOP_RATIO, COMMUNICATION_CHART_SIDE_COLUMN_USABLE_HEIGHT_RATIO, COMMUNICATION_CHART_TEAM_SCOPE_CROSS_TEAM_AGGREGATE_X_RATIO, COMMUNICATION_CHART_TEAM_SCOPE_EXTERNAL_AGGREGATE_X_RATIO } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
var TWO_PI = Math.PI * 2;
export var partitionCommunicationChartNodes = function (nodes) {
    var teamMemberNodes = [];
    var crossTeamNodes = [];
    var syntheticNodes = [];
    var hasExternalAggregateNode = false;
    var hasCrossTeamAggregateNode = false;
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var node = nodes_1[_i];
        if (node.nodeId === COMMUNICATION_CHART_EXTERNAL_NODE_ID) {
            hasExternalAggregateNode = true;
        }
        if (node.nodeId === COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_ID) {
            hasCrossTeamAggregateNode = true;
        }
        if (isCommunicationChartTeamMemberNode(node)) {
            teamMemberNodes.push(node);
        }
        if (isCommunicationChartCrossTeamNodeKind(node.kind)) {
            crossTeamNodes.push(node);
        }
        if (isCommunicationChartSyntheticNodeKind(node.kind)) {
            syntheticNodes.push(node);
        }
    }
    return {
        teamMemberNodes: teamMemberNodes,
        crossTeamNodes: crossTeamNodes,
        syntheticNodes: syntheticNodes,
        hasExternalAggregateNode: hasExternalAggregateNode,
        hasCrossTeamAggregateNode: hasCrossTeamAggregateNode
    };
};
var buildCommunicationChartTeamMemberIndexById = function (teamMemberNodes) {
    var teamIndexById = new Map();
    teamMemberNodes.forEach(function (teamNode, index) {
        teamIndexById.set(teamNode.nodeId, index);
    });
    return teamIndexById;
};
export var communicationChartCenterPosition = function (width, height) { return ({
    x: width / 2,
    y: height / 2
}); };
export var communicationChartRingNodePosition = function (index, total, width, height) {
    var center = communicationChartCenterPosition(width, height);
    var minDim = Math.min(width, height);
    var ringIndex = Math.floor(index / COMMUNICATION_CHART_RING_MAX_NODES_PER_RING);
    var indexInRing = index % COMMUNICATION_CHART_RING_MAX_NODES_PER_RING;
    var nodesInRing = Math.min(COMMUNICATION_CHART_RING_MAX_NODES_PER_RING, total - ringIndex * COMMUNICATION_CHART_RING_MAX_NODES_PER_RING);
    var radius = minDim * COMMUNICATION_CHART_RING_BASE_RADIUS_RATIO +
        ringIndex * minDim * COMMUNICATION_CHART_RING_SPACING_RATIO;
    var angle = (TWO_PI * indexInRing) / Math.max(nodesInRing, 1) - Math.PI / 2;
    return {
        x: center.x + radius * Math.cos(angle),
        y: center.y + radius * Math.sin(angle)
    };
};
export var communicationChartExternalNodePosition = function (width, height) { return ({
    x: width / 2,
    y: height * COMMUNICATION_CHART_BOTTOM_ANCHOR_Y_RATIO
}); };
export var communicationChartTeamScopeBottomAggregateNodePosition = function (nodeId, hasExternal, hasCrossTeamAggregate, width, height) {
    if (hasExternal && hasCrossTeamAggregate) {
        return nodeId === COMMUNICATION_CHART_EXTERNAL_NODE_ID
            ? {
                x: width * COMMUNICATION_CHART_TEAM_SCOPE_EXTERNAL_AGGREGATE_X_RATIO,
                y: height * COMMUNICATION_CHART_BOTTOM_ANCHOR_Y_RATIO
            }
            : {
                x: width * COMMUNICATION_CHART_TEAM_SCOPE_CROSS_TEAM_AGGREGATE_X_RATIO,
                y: height * COMMUNICATION_CHART_BOTTOM_ANCHOR_Y_RATIO
            };
    }
    return communicationChartExternalNodePosition(width, height);
};
export var communicationChartOtherNodePosition = function (width, height) { return ({
    x: width * COMMUNICATION_CHART_OTHER_NODE_X_RATIO,
    y: height * COMMUNICATION_CHART_OTHER_NODE_Y_RATIO
}); };
var resolveCommunicationChartSideColumnLayout = function (layout) {
    var _a, _b;
    if (layout === void 0) { layout = {}; }
    return ({
        topRatio: (_a = layout.topRatio) !== null && _a !== void 0 ? _a : COMMUNICATION_CHART_SIDE_COLUMN_TOP_RATIO,
        usableHeightRatio: (_b = layout.usableHeightRatio) !== null && _b !== void 0 ? _b : COMMUNICATION_CHART_SIDE_COLUMN_USABLE_HEIGHT_RATIO
    });
};
var communicationChartSideColumnPosition = function (index, total, width, height, xRatio, layout) {
    if (layout === void 0) { layout = {}; }
    var _a = resolveCommunicationChartSideColumnLayout(layout), topRatio = _a.topRatio, usableHeightRatio = _a.usableHeightRatio;
    var top = height * topRatio;
    var usableHeight = height * usableHeightRatio;
    var y = total <= 1 ? height / 2 : top + (usableHeight * index) / (total - 1);
    return { x: width * xRatio, y: y };
};
export var communicationChartCrossTeamColumnPosition = function (index, total, width, height, layout) {
    if (layout === void 0) { layout = {}; }
    return communicationChartSideColumnPosition(index, total, width, height, COMMUNICATION_CHART_CROSS_TEAM_COLUMN_X_RATIO, layout);
};
export var communicationChartEmployeeTeammateColumnPosition = function (index, total, width, height, layout) {
    if (layout === void 0) { layout = {}; }
    return communicationChartSideColumnPosition(index, total, width, height, COMMUNICATION_CHART_EMPLOYEE_TEAMMATE_COLUMN_X_RATIO, layout);
};
export var communicationChartEmployeeCrossTeamColumnPosition = function (index, total, width, height, layout) {
    if (layout === void 0) { layout = {}; }
    return communicationChartCrossTeamColumnPosition(index, total, width, height, layout);
};
export var partitionCommunicationChartEmployeeNodes = function (nodes, focusUserId) {
    var focusNode = nodes.find(function (node) { return node.nodeId === focusUserId; });
    var teammateNodes = [];
    var crossTeamNodes = [];
    var hasExternalAggregateNode = false;
    for (var _i = 0, nodes_2 = nodes; _i < nodes_2.length; _i++) {
        var node = nodes_2[_i];
        if (node.nodeId === focusUserId) {
            continue;
        }
        if (node.nodeId === COMMUNICATION_CHART_EXTERNAL_NODE_ID) {
            hasExternalAggregateNode = true;
            continue;
        }
        if (isCommunicationChartCrossTeamNodeKind(node.kind)) {
            crossTeamNodes.push(node);
            continue;
        }
        if (isCommunicationChartTeamMemberNode(node)) {
            teammateNodes.push(node);
        }
    }
    return {
        focusNode: focusNode,
        teammateNodes: teammateNodes,
        crossTeamNodes: crossTeamNodes,
        hasExternalAggregateNode: hasExternalAggregateNode
    };
};
var communicationChartHubSatellitePosition = function (teamIndex, teamTotal, width, height, outwardOffsetPx, angleOffsetRad) {
    var teamPosition = communicationChartRingNodePosition(teamIndex, teamTotal, width, height);
    var center = communicationChartCenterPosition(width, height);
    var dx = teamPosition.x - center.x;
    var dy = teamPosition.y - center.y;
    var distanceToCenter = Math.hypot(dx, dy);
    var signedAngleOffset = teamIndex % 2 === 0 ? angleOffsetRad : -angleOffsetRad;
    if (distanceToCenter < COMMUNICATION_CHART_HUB_SATELLITE_CENTER_EPSILON_PX) {
        return {
            x: teamPosition.x + outwardOffsetPx * Math.cos(signedAngleOffset),
            y: teamPosition.y + outwardOffsetPx * Math.sin(signedAngleOffset)
        };
    }
    var baseAngle = Math.atan2(dy, dx);
    var radialDistance = distanceToCenter + outwardOffsetPx;
    return {
        x: center.x + Math.cos(baseAngle + signedAngleOffset) * radialDistance,
        y: center.y + Math.sin(baseAngle + signedAngleOffset) * radialDistance
    };
};
export var communicationChartInternalMeetNodePosition = function (teamIndex, teamTotal, width, height, outwardOffsetPx, angleOffsetRad) {
    if (outwardOffsetPx === void 0) { outwardOffsetPx = 88; }
    if (angleOffsetRad === void 0) { angleOffsetRad = COMMUNICATION_CHART_INTERNAL_MEET_NODE_ANGLE_OFFSET_RAD; }
    return communicationChartHubSatellitePosition(teamIndex, teamTotal, width, height, outwardOffsetPx, angleOffsetRad);
};
export var communicationChartCrossTeamSpaceNodePosition = function (teamIndex, teamTotal, width, height, outwardOffsetPx, angleOffsetRad) {
    if (outwardOffsetPx === void 0) { outwardOffsetPx = 88; }
    if (angleOffsetRad === void 0) { angleOffsetRad = COMMUNICATION_CHART_CROSS_TEAM_SPACE_NODE_ANGLE_OFFSET_RAD; }
    return communicationChartHubSatellitePosition(teamIndex, teamTotal, width, height, outwardOffsetPx, angleOffsetRad);
};
export var communicationChartExternalSpaceNodePosition = function (teamIndex, teamTotal, width, height, outwardOffsetPx, angleOffsetRad) {
    if (outwardOffsetPx === void 0) { outwardOffsetPx = 88; }
    if (angleOffsetRad === void 0) { angleOffsetRad = COMMUNICATION_CHART_EXTERNAL_SPACE_NODE_ANGLE_OFFSET_RAD; }
    return communicationChartHubSatellitePosition(teamIndex, teamTotal, width, height, outwardOffsetPx, angleOffsetRad);
};
export var resolveHubSatelliteTeamId = function (node) {
    if (node.kind === CommunicationChartNodeKindEnum.InternalMeet) {
        return getCommunicationChartTeamIdForInternalNode(node.nodeId);
    }
    if (node.kind === CommunicationChartNodeKindEnum.CrossTeamSpaceChat) {
        return getCommunicationChartTeamIdForCrossTeamSpaceNode(node.nodeId);
    }
    if (node.kind === CommunicationChartNodeKindEnum.ExternalSpaceChat) {
        return getCommunicationChartTeamIdForExternalSpaceNode(node.nodeId);
    }
    return null;
};
export var resolveSyntheticNodePosition = function (node, context) {
    var teamMemberNodes = context.teamMemberNodes, isDashboardTeamScope = context.isDashboardTeamScope, hasExternalAggregateNode = context.hasExternalAggregateNode, hasCrossTeamAggregateNode = context.hasCrossTeamAggregateNode, width = context.width, height = context.height, _a = context.teamIndexById, teamIndexById = _a === void 0 ? buildCommunicationChartTeamMemberIndexById(teamMemberNodes) : _a;
    if (node.nodeId === COMMUNICATION_CHART_EXTERNAL_NODE_ID) {
        return isDashboardTeamScope
            ? communicationChartTeamScopeBottomAggregateNodePosition(node.nodeId, hasExternalAggregateNode, hasCrossTeamAggregateNode, width, height)
            : communicationChartExternalNodePosition(width, height);
    }
    if (node.nodeId === COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_ID) {
        return isDashboardTeamScope
            ? communicationChartTeamScopeBottomAggregateNodePosition(node.nodeId, hasExternalAggregateNode, hasCrossTeamAggregateNode, width, height)
            : communicationChartExternalNodePosition(width, height);
    }
    if (node.nodeId === COMMUNICATION_CHART_OTHER_NODE_ID) {
        return communicationChartOtherNodePosition(width, height);
    }
    var hubTeamId = resolveHubSatelliteTeamId(node);
    if (hubTeamId === null) {
        return undefined;
    }
    var teamIndex = teamIndexById.get(hubTeamId);
    if (teamIndex === undefined) {
        return undefined;
    }
    var teamTotal = teamMemberNodes.length;
    if (node.kind === CommunicationChartNodeKindEnum.CrossTeamSpaceChat) {
        return communicationChartInternalMeetNodePosition(teamIndex, teamTotal, width, height);
    }
    if (node.kind === CommunicationChartNodeKindEnum.ExternalSpaceChat) {
        return communicationChartExternalSpaceNodePosition(teamIndex, teamTotal, width, height);
    }
    if (node.kind === CommunicationChartNodeKindEnum.InternalMeet) {
        return communicationChartCrossTeamSpaceNodePosition(teamIndex, teamTotal, width, height);
    }
    return undefined;
};
export var applyCommunicationChartRingPositions = function (cy, data, width, height) {
    if (isCommunicationChartEmployeeScope(data.scope) &&
        data.focusUserId != null) {
        var _a = partitionCommunicationChartEmployeeNodes(data.nodes, data.focusUserId), focusNode = _a.focusNode, teammateNodes_1 = _a.teammateNodes, crossTeamNodes_1 = _a.crossTeamNodes, hasExternalAggregateNode_1 = _a.hasExternalAggregateNode;
        if (focusNode) {
            var focusElement = cy.getElementById(String(focusNode.nodeId));
            if (!focusElement.empty()) {
                focusElement.position(communicationChartCenterPosition(width, height));
            }
        }
        teammateNodes_1.forEach(function (node, index) {
            var element = cy.getElementById(String(node.nodeId));
            if (!element.empty()) {
                element.position(communicationChartEmployeeTeammateColumnPosition(index, teammateNodes_1.length, width, height));
            }
        });
        crossTeamNodes_1.forEach(function (node, index) {
            var element = cy.getElementById(String(node.nodeId));
            if (!element.empty()) {
                element.position(communicationChartEmployeeCrossTeamColumnPosition(index, crossTeamNodes_1.length, width, height));
            }
        });
        if (hasExternalAggregateNode_1) {
            var externalElement = cy.getElementById(String(COMMUNICATION_CHART_EXTERNAL_NODE_ID));
            if (!externalElement.empty()) {
                externalElement.position(communicationChartExternalNodePosition(width, height));
            }
        }
        return;
    }
    var _b = partitionCommunicationChartNodes(data.nodes), teamMemberNodes = _b.teamMemberNodes, crossTeamNodes = _b.crossTeamNodes, syntheticNodes = _b.syntheticNodes, hasExternalAggregateNode = _b.hasExternalAggregateNode, hasCrossTeamAggregateNode = _b.hasCrossTeamAggregateNode;
    var isDashboardTeamScope = isCommunicationChartTeamScope(data.scope);
    var teamIndexById = buildCommunicationChartTeamMemberIndexById(teamMemberNodes);
    var layoutContext = {
        teamMemberNodes: teamMemberNodes,
        isDashboardTeamScope: isDashboardTeamScope,
        hasExternalAggregateNode: hasExternalAggregateNode,
        hasCrossTeamAggregateNode: hasCrossTeamAggregateNode,
        width: width,
        height: height,
        teamIndexById: teamIndexById
    };
    teamMemberNodes.forEach(function (node, index) {
        var element = cy.getElementById(String(node.nodeId));
        if (!element.empty()) {
            element.position(communicationChartRingNodePosition(index, teamMemberNodes.length, width, height));
        }
    });
    crossTeamNodes.forEach(function (node, index) {
        var element = cy.getElementById(String(node.nodeId));
        if (!element.empty()) {
            element.position(communicationChartCrossTeamColumnPosition(index, crossTeamNodes.length, width, height));
        }
    });
    syntheticNodes.forEach(function (node) {
        var position = resolveSyntheticNodePosition(node, layoutContext);
        if (!position) {
            return;
        }
        var element = cy.getElementById(String(node.nodeId));
        if (!element.empty()) {
            element.position(position);
        }
    });
};
